// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__43o67","main":"Layout_main__lNxlL"};